export const ACTIVATION_LINK_REQUEST = 'ACTIVATION_LINK_REQUEST';
export const ACTIVATION_LINK_SUCCESS = 'ACTIVATION_LINK_SUCCESS';
export const ACTIVATION_LINK_FAILURE = 'ACTIVATION_LINK_FAILURE';